module.exports = __webpack_public_path__ + "static/media/unchecked-radio.15d74f15.svg";